import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBTableHead,
  MDBTable,
  MDBTableBody,
  MDBContainer,
} from "mdbreact";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";

import {
  showHideLoader,
  closeBooking,
  showNotification,
} from "../../../actions";

import {
  getBookings,
  getStatuses,
  getBookingStatus,
} from "../../../actions/bookingAction";

import { getResource } from "../../../actions/resourceAction";

import _, { set } from "lodash";
import moment from "moment";
import BookingEditor from "./BookingEditor";
import { extractTimezone } from "../../../helper/utils";
import { validateAccess } from "../../../helper/utils";

class BookingManagement extends React.Component {
  state = {
    resultContainer: {},
    isRecurring: false,
    limit: "10",
    status: "",
    query: "",
    page: "1",
    activeItemOuterTabs: "1",
    activeItemInnerPills: "1",
    showBookingDetailsModal: false,
    selectedBookingDetails: {},
    parentBookingId: 0,
    customerId: "",
    isView: true,
    isResourceLoaded: false,
    bookingStatuses: [],
  };

  constructor(props) {
    super(props);
    if (typeof props.parentBookingId !== "undefined") {
      this.state.parentBookingId = props.parentBookingId;
      this.state.startDateFilter = "";
      this.state.endDateFilter = "";
    }

    if (typeof props.customerId !== "undefined") {
      this.state.customerId = props.customerId;
      this.state.startDateFilter = "";
      this.state.endDateFilter = "";
    }

    if (typeof props.isView !== "undefined") {
      this.state.isView = props.isView;
    }
    this.props.getStatuses(this.props.authUser.sessionToken);
  }

  getTzDetails(dt = new Date()) {
    const { locationTimezone } = this.state;
    return extractTimezone(locationTimezone, dt);
  }

  changeHandler = (event) => {
    clearTimeout(this.state.timer);
    let timer = setTimeout(() => {
      this.debouncedDoFilter();
    }, 500);

    this.setState({
      ...this.state,
      timer: timer,
      [event.target.name]: event.target.value,
    });
  };

  componentDidMount() {
    this.props.showHideLoader(true);

    const {
      parentBookingId,
      query,
      customerId,
      startDateFilter,
      endDateFilter,
    } = this.state;

    let params = {};
    if (query !== undefined) {
      params["query"] = query;
    }
    if (customerId != "") {
      params["customerId"] = customerId;
    } else if (parentBookingId > 0) {
      params["parentBookingId"] = parentBookingId;
    } else {
      params["startDate"] = moment(startDateFilter).utc().format("YYYY-MM-DD");
      params["endDate"] = moment(endDateFilter).utc().format("YYYY-MM-DD");
    }

    this.props.getBookings(params, this.props.authUser.sessionToken);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.getBookingsSuccessResponse !==
      this.props.getBookingsSuccessResponse
    ) {
      this.props.showHideLoader(false);
      this.setState({
        resultContainer: this.props.getBookingsSuccessResponse,
        page: this.props.getBookingsSuccessResponse.data.bookings.page,
      });
    }

    if (
      prevProps.isCloseBooking !== this.props.isCloseBooking &&
      this.props.isCloseBooking
    ) {
      this.props.closeBooking(false);
      this.setState({
        bookingDetails: null,
        isResourceLoaded: false,
        showBookingDetailsModal: this.props.isCloseBooking,
      });
    }

    if (
      prevProps.getStatusesSuccessResponse !==
      this.props.getStatusesSuccessResponse
    ) {
      this.props.showHideLoader(false);
      this.setState({
        bookingStatuses: this.props.getStatusesSuccessResponse.data.statuses,
      });
    }

    if (
      prevProps.getResourceResponse !== this.props.getResourceResponse &&
      this.props.getResourceResponse.status === 200 &&
      this.props.getResourceResponse.action == "GET_ITEM"
    ) {
      this.props.showHideLoader(false);
      this.setState({
        locationResource: this.props.getResourceResponse.data,
        isResourceLoaded: true,
      });
    }
    this.validateBookingResponse(prevProps, prevState);
  }

  validateBookingResponse(prevProps, prevState) {
    //-- Success Response
    if (
      prevProps.bookingSuccessResponse !== this.props.bookingSuccessResponse &&
      this.props.bookingSuccessResponse.status === 200
    ) {
      let msg = "Updated booking details";

      this.props.showNotification("success", msg);
      this.props.showHideLoader(false);
      this.setState({ showBookingDetailsModal: false });
      this.debouncedDoFilterOnBookingUpdates();
    }
    //-- Failed Response
    if (
      prevProps.bookingFailedResponse !== this.props.bookingFailedResponse &&
      this.props.bookingFailedResponse.status === 400
    ) {
      this.props.showHideLoader(false);
      this.props.showNotification(
        "error",
        this.props.bookingFailedResponse.data.message
      );

      this.setState({ disableSaveButton: false, disableStatusButton: false });
    }
    // else if (this.state.invalidCoupon) {
    //   this.props.showHideLoader(false);
    //   return (
    //     <MDBAlert color="danger" className="text-center">
    //       Invalid Discount code provided
    //     </MDBAlert>
    //   );
    // }
    else if (
      prevProps.bookingFailedResponse !== this.props.bookingFailedResponse &&
      this.props.bookingFailedResponse === "Network error"
    ) {
      this.props.showHideLoader(false);

      let msg = this.state.isUpdate
        ? "Unable to update details. Please try again later"
        : "Unable to book customer. Please try again later";

      this.props.showNotification("error", msg);

      this.setState({ disableSaveButton: false, disableStatusButton: false });
    }
  }

  debouncedDoFilter = _.debounce(function () {
    this.doFilter();
  }, 500);

  debouncedDoFilterOnBookingUpdates = _.debounce(function () {
    this.doFilter();
  }, 1000);

  doFilter() {
    const {
      startDateFilter,
      endDateFilter,
      status,
      isRecurring,
      page,
      limit,
      query,
      parentBookingId,
      customerId,
    } = this.state;
    this.props.showHideLoader(true);
    let params = {};
    if (startDateFilter) {
      params["startDate"] = moment(startDateFilter).utc().format("YYYY-MM-DD");
    }
    if (endDateFilter) {
      params["endDate"] = moment(endDateFilter).utc().format("YYYY-MM-DD");
    }
    if (status !== undefined && status.length > 0) {
      params["status"] = status;
    }
    if (isRecurring) {
      params["isRecurring"] = 1;
    }
    if ((page + "").length > 0) {
      params["page"] = page;
    }
    if (limit.length > 0) {
      params["limit"] = limit;
    }

    if (query !== undefined) {
      params["query"] = query;
    }

    if (customerId !== undefined && customerId != "") {
      params["customerId"] = customerId;
    }

    if (parentBookingId > 0) {
      params["parentBookingId"] = parentBookingId;
    }

    this.props.getBookings(params, this.props.authUser.sessionToken);
  }

  render() {
    return (
      <div>
        {this.renderBookingDetailsForm()}
        {this.renderTable()}
      </div>
    );
  }

  renderTable() {
    const { resultContainer, page } = this.state;
    const { storeUserAccess } = this.props;
    let columns = [
      {
        label: "Reference",
        field: "heading0",
        sort: "asc",
      },
      {
        label: "Date",
        field: "heading1",
        sort: "asc",
      },
      {
        label: "Time",
        field: "heading2",
        sort: "asc",
      },
      {
        label: "Day",
        field: "heading3",
        sort: "asc",
      },
      {
        label: "Location",
        field: "heading4",
        sort: "asc",
      },
      {
        label: "Resource",
        field: "heading5",
        sort: "asc",
      },
      {
        label: "Name",
        field: "heading6",
        sort: "asc",
      },
      {
        label: "Email",
        field: "heading7",
        sort: "asc",
      },
      {
        label: "INV #",
        field: "heading8",
        sort: "asc",
      },

      {
        label: "Status",
        field: "heading9",
        sort: "asc",
      },
      {
        label: "",
        field: "heading10",
        sort: "asc",
      },
    ];

    let removeColumns = ["heading4", "heading6", "heading7"];
    if (!this.state.isView) {
      for (let index = 0; index < columns.length; index++) {
        if (removeColumns.includes(columns[index].field)) {
          delete columns[index];
        }
      }
    }
    const data = {
      columns: columns,
    };
    let rows = [];
    if (resultContainer.status === 200) {
      rows = _.chain(resultContainer.data.bookings.results)
        .map((result, index) => {
          var status =
            result.status +
            " - " +
            (result.is_paid ? "Paid" : "Payment Pending");
          let row = {
            heading0: result.booking_reference,
            heading1: moment(result.start_time)
              .tz(this.getTzDetails().timezone)
              .format("DD/MM/YYYY"),
            heading2:
              moment(result.start_time)
                .tz(this.getTzDetails().timezone)
                .format("HH:mm") +
              "-" +
              moment(result.end_time)
                .tz(this.getTzDetails().timezone)
                .format("HH:mm"),
            heading3: moment(result.start_time)
              .tz(this.getTzDetails().timezone)
              .format("dddd"),
            heading4: result.location.name,
            heading5: result.resource.name,
            heading6: result.customer.fullname,
            heading7: result.customer.email,
            heading8: result.transaction.invoice,
            heading9: status,
            heading10: validateAccess(
              storeUserAccess,
              "RecurringBookings",
              "viewBookingDetails"
            ) && (
              <MDBBtn
                color="primary"
                size="sm"
                key={index}
                onClick={() => this.openBookingDetailsModal(true, result)}
              >
                {this.state.isView ? "View Booking" : "Manage Booking"}
              </MDBBtn>
            ),
          };

          if (!this.state.isView) {
            Object.keys(row).forEach((key) => {
              if (removeColumns.includes(key)) {
                delete row[key];
              }
            });
          }

          return row;
        })
        .value();

      data["rows"] = rows;
      return (
        <MDBContainer>
          <MDBTable responsive striped bordered>
            <MDBTableHead columns={data.columns} />
            <MDBTableBody rows={data.rows} />
          </MDBTable>
          <MDBRow>
            <MDBCol md="12">
              <div className="float-right">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={resultContainer.data.bookings.totalPage}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={4}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      );
    }
    return <div></div>;
  }

  handlePageClick = (e) => {
    const selectedPage = e.selected + 1;
    this.setState({
      page: selectedPage,
    });
    this.debouncedDoFilter();
  };

  openBookingDetailsModal(showBookingDetailsModal, source) {
    if (source !== null) {
      this.props.showHideLoader(true);
      this.props.getResource(
        source.resource.uuid,
        this.props.authUser.sessionToken
      );
      this.setState({
        showBookingDetailsModal: showBookingDetailsModal,
        bookingDetails: source,
      });
    } else {
      this.setState({
        showBookingDetailsModal: showBookingDetailsModal,
        bookingDetails: null,
        isResourceLoaded: false,
      });
    }
  }

  renderBookingDetailsForm() {
    if (this.state.showBookingDetailsModal && this.state.isResourceLoaded) {
      var locationResource = this.state.locationResource;
      return (
        <div>
          <BookingEditor
            doCalculate={true}
            statuses={this.state.bookingStatuses}
            selectedBooking={this.state.bookingDetails}
            locationResource={locationResource}
            isView={false}
          />
        </div>
      );
    }
    return <span></span>;
  }
}

const mapStateToProps = (state) => {
  return {
    getBookingsSuccessResponse: state.getBookingsSuccessResponse,
    getBookingsFailedResponse: state.getBookingsFailedResponse,
    authUser: state.authUser,
    getStatusesSuccessResponse: state.getStatusesSuccessResponse,
    getStatusesFailedResponse: state.getStatusesFailedResponse,
    getBookingStatusSuccessResponse: state.getBookingStatusSuccessResponse,
    getBookingStatusFailedResponse: state.getBookingStatusFailedResponse,
    getResourceResponse: state.resourceResponse,
    isCloseBooking: state.closeBooking,
    bookingSuccessResponse: state.bookingSuccessResponse,
    bookingFailedResponse: state.bookingFailedResponse,
    storeUserAccess: state.storeUserAccess,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getBookings,
    getStatuses,
    getBookingStatus,
    showHideLoader,
    closeBooking,
    getResource,
    showNotification,
  })(BookingManagement)
);
